 <template>
      <div class="map-canvas" id="map-canvas"></div>
</template>
<script>
import mapSettings from '../../lib/map';
import svg from '../../lib/svg';

export default {
  name: 'Business Profile',
  props: ['lat','lng','lid'],
  data() {
    return {
      title: "Mapping System",
    }
  },
  mounted(){
    this.loadMap();
  },
methods:{   
    loadMap(){
        
        this.map = new google.maps.Map(document.getElementById('map-canvas'), {
            zoom: 18,
            center: new google.maps.LatLng(this.lat, this.lng),
             mapTypeId: 'roadmap',
           styles: mapSettings.style
        });
        
        this.markers = new google.maps.Marker({
            position: new google.maps.LatLng(this.lat,this.lng),
            map: this.map,
        });
    }
 }
}
</script>


// WEBPACK FOOTER //
// src/components/mapping/business-profile.vue